import React from "react";

import Loader from "components/YandexMapsScriptLoader";
import Component from "./Component";

class MapLoader extends React.Component {
    render() {
        return (
            <Loader>
                <Component key="key" {...this.props} />
            </Loader>
        );
    }
}

export default MapLoader;
